<mat-card class="chatWidgetCard">
  <mat-card-header>
    <mat-card-subtitle *ngIf="channel">
      <button mat-icon-button (click)="unselectChannel()"><sn-icon>arrow_back</sn-icon></button>
      <span class="title">
        {{ channel.name }}
      </span>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content *ngIf="chatLoaded; else loading">
    <sn-chat-channel-list
      *ngIf="!channel"
      (channelSelected)="selectChannel($event)"
    ></sn-chat-channel-list>
    <div *ngIf="channel">
      <ng-container *ngIf="userHasAccess; else joinTmpl">
        <sn-message-list *ngIf="channel.twilioChannel" [channel]="channel"> </sn-message-list>
      </ng-container>
      <ng-template #joinTmpl>
        <div class="join-container">
          <h3>{{ 'map.tools.chatDrawer.notJoinedMessage' | t }}</h3>
          <br /><br />
          <button mat-button color="success" (click)="join()">{{ 'map.tools.chatDrawer.joinChannel' | t }}</button>
        </div>
      </ng-template>
    </div>
  </mat-card-content>
  <ng-template #loading>
    <mat-card-content>
      <mat-spinner
        class="chat-widget__spinner"
        color="accent"
        diameter="48"
        mode="indeterminate"
      ></mat-spinner>
    </mat-card-content>
  </ng-template>
  <mat-card-actions>
    <sn-new-message
      *ngIf="channel?.twilioChannel"
      class="chat"
      [channel]="channel"
    ></sn-new-message>
  </mat-card-actions>
</mat-card>
